
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cauta/[[...filters]]",
      function () {
        return require("private-next-pages/cauta/[[...filters]].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cauta/[[...filters]]"])
      });
    }
  